import Logo from '../../assets/branding/colour-logo.png';
import parrotBitesize from '../../assets/images/parrot-cutout-bitesize.png';

const Loader = ({ progress = null, children }) => {
  let percent = null;

  if (progress) {
    percent = 0;
    if (progress.value.length > 0) {
      percent = `${(progress.value.length / progress.length) * 100}%`;
    }
  }

  return (
    <div className="loader">
      <img src={Logo} alt="golingo Parrot" title="golingo Parrot" />
      <p>{children}</p>
      {progress && (
        <div className="progress-bar">
          <img
            src={parrotBitesize}
            className="progress-bar__parrot"
            style={{ left: `calc(${percent} - 30px)` }}
            alt="golingo Parrot"
          />
          <div className="bar-container">
            <div className="bar" style={{ width: percent }}></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loader;
